import styled from 'styled-components/macro';
import Box from './Box';

export default styled(Box)`
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0 16px;
  max-width: 1200px;
  z-index: 0;
`;
